export const pageSection =
  'bg-apps-coreGrayWhite px-0 text-apps-brandGrayBlack';

export const shell =
  'relative mx-auto w-full max-w-[1248px] border-x border-[#e8e8e5] bg-apps-coreGrayWhite';

export const gridGuides =
  'pointer-events-none absolute inset-0 hidden md:block [&_span]:absolute [&_span]:inset-y-0 [&_span]:w-px [&_span]:bg-[#ecece9]';

export const breadcrumbRow =
  'relative z-[3] flex h-16 items-center bg-apps-coreGrayWhite px-5 md:h-20 md:px-4';

export const breadcrumb =
  'group inline-flex min-h-11 items-center gap-2 py-2 text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-apps-corePrimary01';

export const breadcrumbIcon =
  'inline-flex text-[#777773] transition-[color,transform] duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:-translate-x-1 group-hover:text-apps-brandGrayBlack group-focus-visible:-translate-x-1 group-focus-visible:text-apps-brandGrayBlack motion-reduce:transform-none motion-reduce:transition-none';

export const breadcrumbIconGlyph = 'rotate-180';

export const breadcrumbLabel =
  'text-[#777773] transition-colors duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:text-apps-brandGrayBlack group-focus-visible:text-apps-brandGrayBlack motion-reduce:transition-none';

export const customerStage =
  'relative z-[1] isolate flex h-[clamp(340px,48svh,460px)] w-full items-center justify-center overflow-hidden border-b border-[#d8d8d5] bg-[#dededb] px-5 text-center md:h-[clamp(320px,42svh,440px)]';

export const customerMedia =
  'pointer-events-none absolute inset-0 z-0 overflow-hidden';

export const customerImageMotion =
  'absolute inset-[-190px] origin-center [filter:blur(var(--case-parallax-blur))] [transform:translate3d(0,var(--case-parallax-offset),0)_scale(var(--case-parallax-scale))] will-change-transform motion-reduce:transform-none motion-reduce:filter-none';

export const customerImage =
  'select-none object-cover object-[48%_50%] opacity-50 blur-[1px] md:object-center';

export const customerImageTint =
  'pointer-events-none absolute inset-0 z-[1] bg-white/[0.54]';

export const customerIdentity = 'relative z-[2]';

export const customerName =
  'text-[clamp(58px,8vw,104px)] font-black leading-none tracking-[-0.065em] text-apps-brandGrayBlack';

export const customerMeta =
  'mt-5 block text-sm font-semibold leading-[1.5] text-[#777773]';

export const introStage =
  'relative z-[1] grid border-b border-[#e8e8e5] md:grid-cols-4';

export const introContent =
  'px-5 py-16 md:col-span-3 md:col-start-2 md:px-10 md:py-[84px] lg:px-20';

export const soundLabel = 'text-sm font-semibold leading-[1.4] text-[#686864]';

export const title =
  'mt-5 max-w-[820px] text-[clamp(40px,5.2vw,68px)] font-semibold leading-[1.05] tracking-[-0.045em] text-apps-brandGrayBlack text-balance';

export const lead =
  'mt-8 max-w-[720px] text-[18px] font-medium leading-[1.68] tracking-[-0.012em] text-[#3f3f3c] md:text-xl';

export const contentGrid = 'relative z-[1] grid md:grid-cols-4';

export const article =
  'min-w-0 px-5 pt-16 pb-0 md:col-span-3 md:col-start-2 md:px-10 md:pt-[104px] md:pb-0 lg:px-20';

export const proseSection = 'mb-20 md:mb-28';

export const sectionHeading =
  'max-w-[720px] text-[clamp(30px,3.4vw,46px)] font-semibold leading-[1.18] tracking-[-0.025em] text-apps-brandGrayBlack text-balance';

export const prose =
  'mt-7 grid max-w-[680px] gap-7 text-[17px] font-medium leading-[1.72] tracking-[-0.012em] text-[#30302d] [word-break:keep-all] md:gap-8 md:text-lg';

export const challengeParagraph = 'text-[#30302d]';

export const closingMetric = 'mt-10 max-w-[680px] ';

export const closingMetricValue =
  'block text-[clamp(36px,5vw,58px)] font-semibold leading-[1.05] tracking-[-0.04em] text-apps-brandGrayBlack';

export const closingMetricLabel =
  'mt-4 block text-base font-medium leading-[1.6] tracking-[-0.01em] text-[#3f3f3c]';

/** Bulleted fact list used by tasks, site conditions, and system setup */
export const factList =
  'mt-7 grid max-w-[680px] list-disc gap-3 pl-5 text-[17px] font-medium leading-[1.72] tracking-[-0.012em] text-[#30302d] [word-break:keep-all] md:text-lg';

export const factListItem = 'pl-1 marker:text-[#a9a9a3]';

/** Two-column before and after comparison */
export const comparisonGrid =
  'mt-7 grid max-w-[680px] gap-px border border-[#e0e0dc] bg-[#e0e0dc] sm:grid-cols-2';

export const comparisonCell = 'bg-apps-coreGrayWhite px-5 py-6';

export const comparisonLabel =
  'block text-[13px] font-semibold uppercase tracking-[0.08em] text-[#84847e]';

export const comparisonValue =
  'mt-3 block text-[17px] font-medium leading-[1.6] tracking-[-0.012em] text-[#30302d] [word-break:keep-all]';

/** Measurement conditions and limitations, shown as labelled notes */
export const noteList = 'mt-7 grid max-w-[680px] gap-6';

export const noteTerm = 'text-[13px] font-semibold text-[#84847e]';

export const noteDescription =
  'mt-2 text-[16px] font-medium leading-[1.68] tracking-[-0.012em] text-[#3f3f3c] [word-break:keep-all]';

/** Publication dates shown under the lead and again above the references */
export const publicationMeta =
  'flex flex-wrap items-center gap-x-5 gap-y-1 text-[13px] font-medium leading-[1.6] text-[#777773]';

/** Hero classification line: industry, process, inspection target */
export const classificationList =
  'mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-semibold leading-[1.5] text-[#686864]';

export const classificationSeparator = 'text-[#b4b4ad]';
